'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  SALES_PRO: 'sales-pro',
  SALES_STARTER: 'sales-starter',
  SALES_PROFESSIONAL: 'sales-professional',
  SALES_ENTERPRISE: 'sales-enterprise',

  MARKETING_STARTER: 'marketing-starter',
  MARKETING_STARTER_EMAIL: 'marketing-starter-email',
  MARKETING_BASIC: 'marketing-basic',
  MARKETING_PRO: 'marketing-pro',
  MARKETING_ENTERPRISE: 'marketing-enterprise',

  SERVICE_STARTER: 'service-starter',
  SERVICE_PROFESSIONAL: 'service-professional',
  SERVICE_ENTERPRISE: 'service-enterprise',

  ADS: 'ads',
  WEBSITE: 'website',
  REPORTING: 'reporting',
  DEDICATED_IP: 'dedicated-ip',
  TRANSACTIONAL_EMAIL: 'transactional-email',
  ADDITIONAL_ACCOUNT: 'additional-account',
  BRAND_DOMAIN: 'brand-domain',

  DESIGNATED_TECHNICAL_SUPPORT: 'designated-technical-support',
  IN_PERSON_TRAINING: 'in-person-training',
  STARTER_KIT: 'starter-kit',
  SALES_PROFESSIONAL_ONBOARDING: 'sales-professional-onboarding',
  SERVICE_PROFESSIONAL_ONBOARDING: 'service-professional-onboarding',

  // Used only for free product activation
  CMS: 'cms',
  CRM: 'crm',
  SALES_FREE: 'sales-free',
  MARKETING_FREE: 'marketing-free',
  SERVICE_FREE: 'service-free',

  // Used only for bundled enterprise trial
  ENTERPRISE_TRIAL: 'enterprise-trial'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/constants/UpgradeProducts.js
// module id = 170
// module chunks = 3 4 5